// extracted by mini-css-extract-plugin
export default {"backToSitesButton":"ButtonComeBack_backToSitesButton__kUOlG","iconBack":"ButtonComeBack_iconBack__NSvO7","backButtonWithText":"ButtonComeBack_backButtonWithText__vDVak"};